import script from "./BPopTransition.vue?vue&type=script&lang=ts"
export * from "./BPopTransition.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__